import {Component, Input, OnInit} from '@angular/core';
import {Newsletter} from "../../../shared/interface/newsletter";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {FormBuilder} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {HttpErrorResponse} from "@angular/common/http";
import {NewsletterService} from "../../../shared/services/newsletter.service";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";

@Component({
  selector: 'app-newsletter-details',
  templateUrl: './newsletter-details.component.html',
  styleUrls: ['./newsletter-details.component.scss']
})
export class NewsletterDetailsComponent implements OnInit {
  @Input() disableBreadcrumb = false;
  @Input() dialogRef?: MatDialogRef<DocumentAddDialogComponent>;

  newsletterObject: Newsletter;
  newsletterId: string;
  newsletter: ReplaySubject<Newsletter> = new ReplaySubject<Newsletter>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
    private newsletterService: NewsletterService
  ) {
    this.userPermissions = this.auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        if (params.id === undefined) {
          return;
        }
        this.newsletterId = params.id;
        this.loadNewsletter();
      });
  }

  loadNewsletter(): void {
    this.newsletterService.get(this.newsletterId).subscribe((newsletter: Newsletter) => {
      this.newsletter.next(newsletter);
      this.newsletterObject = newsletter;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych newslettera', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/newsletter/historia']);
    });
  }

}
